import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initWebVitals } from "./lib/web-vitals";

createRoot(document.getElementById("root")!).render(<App />);

// Report Core Web Vitals (LCP, INP, CLS, FCP, TTFB) to GA4. Runs on idle so
// it never blocks rendering and respects GA4 Consent Mode.
initWebVitals();
